import { type GkAirRecommendedProductDataWeb } from '@redteclab/api/clients/crosssellers-proxy-service'

import { apmCaptureError } from '../../apm'
import { type LOCALE } from '../../i18n'

import { gkAirAccessorGetUnderscoreLocale } from './gkAirAccessorGetUnderscoreLocale'

export const gkAirAccessorGetLocalizedProductUnit = ({
  locale,
  product,
}: {
  locale: LOCALE
  product: GkAirRecommendedProductDataWeb
}): string => {
  const productUrl =
    product[`package_size_unit_${gkAirAccessorGetUnderscoreLocale(locale)}`]

  if (!productUrl) {
    apmCaptureError(
      new Error(
        `GK_AIR: product unit not found for "${product.UID}" for ${locale}`,
      ),
    )

    return ''
  }

  return productUrl
}
